import { fetchPricingDisplayV2 } from "@/components/Pricing/v2/handlers/fetchPricingDisplayData";
import { useQuery } from "@tanstack/react-query";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { useEffect } from "react";
import { useSigninCheck } from "reactfire";

export const QUERY_KEY_PRICING_DISPLAY = "pricing-display-data" as const;

const usePricingDisplayData = (lang?: string) => {
  const auth = getAuth();
  const { status } = useSigninCheck();

  const query = useQuery({
    queryKey: [QUERY_KEY_PRICING_DISPLAY],
    queryFn: async () => {
      let token;
      try {
        token = await auth.currentUser?.getIdToken();
      } catch (e) {
        console.log(e);
      }
      return fetchPricingDisplayV2(lang ?? "EN", token);
    },
    enabled: status === "success",
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
  });

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, () => {
      query.refetch();
    });

    return unsubscribe;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth]);

  return query;
};

export default usePricingDisplayData;
